module.exports = __webpack_public_path__ + "ic-redeem-points-white.svg?a566bc662bd21d51d8bb2b3d492304f2";